import { render, staticRenderFns } from "./LocaleNew.vue?vue&type=template&id=47b59c41&scoped=true"
import script from "./LocaleNew.vue?vue&type=script&lang=js"
export * from "./LocaleNew.vue?vue&type=script&lang=js"
import style0 from "./LocaleNew.vue?vue&type=style&index=0&id=47b59c41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b59c41",
  null
  
)

export default component.exports